import { JobHistory } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/person-job-info/components/job-history';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ContactOverviewJobHistoryPopoverProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;

export const ContactOverviewJobHistoryPopover = memo(
  ({ className, state, allPresentRoles }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ContactOverviewJobHistoryPopover', className)}
        sx={SX.root}
        state={state}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
        contentSx={{ overflowY: 'hidden' }}
        disableRestoreFocus
      >
        <JobHistory isCompanySummary={false} currentRoles={allPresentRoles} />
      </Styled.Wrapper>
    );
  }
);

ContactOverviewJobHistoryPopover.displayName =
  'ContactOverviewJobHistoryPopover';
